'use es6';

import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIImage from 'UIComponents/image/UIImage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
export default createReactClass({
  displayName: "CertificationBadges",
  propTypes: {
    certifications: PropTypes.object.isRequired
  },
  render: function render() {
    var certifications = this.props.certifications;

    if (!certifications.size) {
      return React.createElement("div", null, React.createElement(FormattedMessage, {
        message: "MarketplaceUI.goodDetailsPage.info.certifications.noCertifications"
      }));
    }

    return React.createElement("div", null, this.props.certifications.map(function (award) {
      return React.createElement(UITooltip, {
        key: award.get('awardName'),
        title: award.getIn(['displayNames', I18n.locale], award.get('defaultName'))
      }, React.createElement(UIImage, {
        className: "m-right-1 m-bottom-1",
        responsive: false,
        src: award.get('iconUrl'),
        style: {
          cursor: 'help'
        },
        width: 24
      }));
    }));
  }
});